/* eslint-disable @typescript-eslint/no-explicit-any */
import { NotificationInstance } from 'antd/lib/notification';
import { Context } from 'components/hoc/Store';
import { ENotificationPlacement } from 'enums/notificationPlacement';
import { ENotificationType } from 'enums/notificationType';
import React from 'react';
import getLanguageObject from 'utils/getLanguageObject';

export interface INotification {
    type?: ENotificationType;
    title?: any;
    description?: any;
    duration?: number;
    placement?: ENotificationPlacement;
}
const NotificationWrapper = (notificationApi: NotificationInstance) => (props: INotification) => {
    const {
        type = ENotificationType.OPEN,
        title,
        description,
        duration = 4.5,
        placement = ENotificationPlacement.TOPRIGHT
    } = props;

    if (type === ENotificationType.OPEN)
        return notificationApi.open({
            message: (
                <Context.Consumer>{({ language }) => getLanguageObject(language)[title] || title}</Context.Consumer>
            ),
            description: (
                <Context.Consumer>
                    {({ language }) => getLanguageObject(language)[description] || description}
                </Context.Consumer>
            ),
            duration: duration,
            placement: placement
        });

    if (type === ENotificationType.SUCCESS)
        return notificationApi.success({
            message: (
                <Context.Consumer>{({ language }) => getLanguageObject(language)[title] || title}</Context.Consumer>
            ),
            description: (
                <Context.Consumer>
                    {({ language }) => getLanguageObject(language)[description] || description}
                </Context.Consumer>
            ),
            duration: duration,
            placement: placement
        });

    if (type === ENotificationType.ERROR)
        return notificationApi.error({
            message: (
                <Context.Consumer>{({ language }) => getLanguageObject(language)[title] || title}</Context.Consumer>
            ),
            description: (
                <Context.Consumer>
                    {({ language }) => getLanguageObject(language)[description] || description}
                </Context.Consumer>
            ),
            duration: duration,
            placement: placement
        });

    if (type === ENotificationType.INFO)
        return notificationApi.info({
            message: (
                <Context.Consumer>{({ language }) => getLanguageObject(language)[title] || title}</Context.Consumer>
            ),
            description: (
                <Context.Consumer>
                    {({ language }) => getLanguageObject(language)[description] || description}
                </Context.Consumer>
            ),
            duration: duration,
            placement: placement
        });

    if (type === ENotificationType.WARNING)
        return notificationApi.warning({
            message: (
                <Context.Consumer>{({ language }) => getLanguageObject(language)[title] || title}</Context.Consumer>
            ),
            description: (
                <Context.Consumer>
                    {({ language }) => getLanguageObject(language)[description] || description}
                </Context.Consumer>
            ),
            duration: duration,
            placement: placement
        });
};

export default NotificationWrapper;
